module.exports = __webpack_public_path__ + "img/product12.fc2f63f3.png";